import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import ApproveCollateral from "./ApproveCollateral";

const CollateralMainActionPage = (props) => {
  const { userData } = props;
  const { state } = useLocation();

  const renderActions = () => {
    switch (state?.actionLabel?.toLowerCase()) {
      case "approve":
        return <ApproveCollateral userData={userData} />;

      default:
        return <>No {state.actionLabel} Component found contact dev</>;
    }
  };

  return <>{renderActions()}</>;
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(CollateralMainActionPage);
